<div class="lateral-menu-container" *ngIf="submenuItems?.length">
  <mat-card>
    <mat-card-title>
      <div class="menu-lateral-title" *ngIf="showTitle">
        <span>Select a chart to view</span>
        <span class="flex-spacer"></span>
        <a mat-icon-button matTooltip="Download data" (click)="intelligence ? openDownloadDialog('intelligence') : openDownloadDialog()"><mat-icon class="material-icons-outlined">cloud_download</mat-icon></a>
      </div>
    </mat-card-title>
    <mat-card-title *ngIf="intelligenceReporting">
      <div class="menu-lateral-title">
        <span></span>
        <span class="flex-spacer"></span>
        <a mat-icon-button matTooltip="Download data" (click)="openDownloadDialog('intelligencereporting')"><mat-icon class="material-icons-outlined">cloud_download</mat-icon></a>
      </div>
    </mat-card-title>
    <mat-accordion>
      <mat-expansion-panel hideToggle *ngFor="let item of submenuItems" class="menu-panel">
        <mat-expansion-panel-header
          [ngClass]="currentUrl.includes(item.link) ? 'selected' : ''"
          *ngIf="!item?.submenus?.length"
          routerLink="{{item.link}}">
          {{ item.title }}
        </mat-expansion-panel-header>
        <mat-expansion-panel-header *ngIf="item?.submenus?.length">
          {{ item.title }}
        </mat-expansion-panel-header>
        <mat-nav-list *ngIf="item?.submenus?.length">
          <mat-list-item *ngFor="let option of item?.submenus; let i = index" routerLink="{{option.link}}">
            <span>{{option.title}}
            </span>
          </mat-list-item>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card>
</div>

